import { handleApiError } from '@/handleApiError'
import api from '@/modules/collection/api'
import helpers from '@/modules/message/helpers'
import { t } from '@/plugins/i18n.ts'
import { EmailPreview, SendCollectionPostDto } from '@/types/index'
import { defineStore } from 'pinia'

interface CollectionEmailState {
  item: EmailPreview | undefined
  loading: boolean
  sending: boolean
}

const initialState = (): CollectionEmailState => {
  return {
    item: undefined,
    loading: false,
    sending: false
  }
}

const useCollection = defineStore('collectionEmail', {
  state: () => initialState(),
  actions: {
    async getEmailPreview(id: string) {
      this.loading = true

      return api
        .getEmailPreview(id)
        .then(({ data }) => {
          this.item = data
        })
        .catch(handleApiError)
        .finally(() => (this.loading = false))
    },
    async sendEmail(id: string, dto: SendCollectionPostDto) {
      this.sending = true

      return api
        .sendEmail(id, dto)
        .then(() => helpers.reportSuccess(t('collection.emailSent')))
        .catch(handleApiError)
        .finally(() => (this.sending = false))
    }
  }
})

export default useCollection
